import React from 'react'
import { CustomModal } from '../CustomModal/CustomModal';
import useWindowSize from '../../customHooks/useWindowSize';
import { EntryAndDepartureDetail } from './EntryAndDepartureDetail/EntryAndDepartureDetail';

export const EntryAndDepartureModal = ({ showDetailModal, setShowDetailModal, resourceInfo }) => {
    const { windowWidth } = useWindowSize();
    const putMobileView = windowWidth <= 650;

    return (
        <CustomModal
            showModal={showDetailModal}
            setShowModal={setShowDetailModal}
            backgroundColor={'var(--gray-50)'}
            backdrop=''
            fullscreen={putMobileView ? true : false}
            btnClose={true}
        >
            <EntryAndDepartureDetail
                showDetailModal={showDetailModal}
                setShowDetailModal={setShowDetailModal}
                resourceInfo={resourceInfo}
            />

        </CustomModal>
    )
}
